/**
 * Capira Security — assets/capira-security.js
 * Scroll-triggered reveals, circuit line draw, pillar stagger.
 */
(function () {
  'use strict';

  const pref    = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const section = document.getElementById('capira-security');
  if (!section) return;

  function observe(target, cb, threshold) {
    if (pref) { cb(); return; }
    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) { cb(); io.disconnect(); }
    }, { threshold: threshold || 0.08 });
    io.observe(target);
  }

  /* ── 1. Circuit background draw ─────────────────── */
  observe(section, () => {
    section.classList.add('is-drawing');
  }, 0.04);

  /* ── 2. Statement text reveals ───────────────────── */
  const revealEls = section.querySelectorAll('[data-sec-reveal]');
  observe(section.querySelector('.capira-sec__statement') || section, () => {
    revealEls.forEach(el => {
      const d = parseInt(el.dataset.secDelay || '0', 10);
      setTimeout(() => el.classList.add('is-visible'), pref ? 0 : d);
    });
  }, 0.06);

  /* ── 3. Dividers draw in ─────────────────────────── */
  section.querySelectorAll('[data-sec-rule]').forEach((el, i) => {
    observe(el, () => {
      setTimeout(() => el.classList.add('is-visible'), pref ? 0 : i * 120);
    }, 0.02);
  });

  /* ── 4. Pillars + vertical rules ─────────────────── */
  const pillarsWrap = section.querySelector('.capira-sec__pillars');
  if (pillarsWrap) {
    observe(pillarsWrap, () => {
      section.querySelectorAll('[data-sec-pillar]').forEach((p, i) => {
        setTimeout(() => p.classList.add('is-visible'), pref ? 0 : i * 100);
      });
      section.querySelectorAll('.capira-sec__pillar-rule').forEach((r, i) => {
        setTimeout(() => r.classList.add('is-visible'), pref ? 0 : 200 + i * 60);
      });
    }, 0.06);
  }

  /* ── 5. Shopify design mode ──────────────────────── */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      if (!e.target.contains(section)) return;
      section.classList.add('is-drawing');
      revealEls.forEach(el => el.classList.add('is-visible'));
      section.querySelectorAll('[data-sec-rule], [data-sec-pillar], .capira-sec__pillar-rule').forEach(el => el.classList.add('is-visible'));
    });
  }

})();
